import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { HisInformationSetting } from "../../../../base/domain/his";

export interface IHisInformationKeyPropertyEditable {
  hisInformationKey(): IPropertyEditable<string>;
  getHisInformationName(): string;
  getSelectableHisInformations(): HisInformationSetting[];
  getSelectedHisInformation(): HisInformationSetting;
  isHisInformationMixable(): boolean; // HIS情報選択とそれ以外を同時に扱えるかを示す.
}

export function instanceOfIHisInformationKeyPropertyEditable(instance: any): instance is IHisInformationKeyPropertyEditable {
  return instance
      && instance.hisInformationKey
      && instance.getHisInformationName
      && instance.getSelectableHisInformations
      && instance.isHisInformationMixable
      && instanceOfIPropertyEditable<string>(instance.hisInformationKey());
}
